import { useContext, useEffect, useState } from "react";
import { NetworkConfig } from "src/network/NetworkConfig";
import { useHistory } from "react-router-dom";
import { Route } from "src/config/routes";
import { RootStoreContext } from "src/stores/RootStore";
import Axios from "src/network/Axios";

export const useSystemHealthCheck = () => {
    const { authStore } = useContext(RootStoreContext);
    const history = useHistory();
    const [hasSystemHealthBeenChecked, setHasSystemHealthBeenChecked] = useState<boolean>(false);

    useEffect(() => {
        if (!hasSystemHealthBeenChecked && authStore.token) {
            const checkSystemHealth = async () => {
                if (!NetworkConfig.isMaintenanceActive) {
                    try {
                        const getSystemHealthResponse = await Axios.getInstance().get(NetworkConfig.systemHealthUrl);
                        if (getSystemHealthResponse.status !== 200) {
                            setHasSystemHealthBeenChecked(true);
                            history.push(Route.systemHealthError);
                        }
                    } catch (error) {
                        setHasSystemHealthBeenChecked(true);
                        history.push(Route.systemHealthError);
                    }
                }
            };

            checkSystemHealth();
            setHasSystemHealthBeenChecked(true);
        }
    }, [hasSystemHealthBeenChecked, history, authStore.token]);
};
